import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Field, Input, Textarea } from '~/components/Form';
import { srOnlyStyle } from '~/styles/utilities.css';
import { clsx } from '~/styles/utils';

import { useFormWithLinesContext } from '../../FormLines.context';
import { useLineContext } from '../../SectionLines/SectionLines.context';
import { fieldStyle } from './FormDescription.css';

export const FormDescription = () => {
  const { control } = useFormWithLinesContext();
  const { isMobile, isProductLine, line, lineFieldName } = useLineContext();
  const isTextLine = line.type === 'text';

  const { t } = useTranslation(['lines', 'validation']);

  const label = isProductLine
    ? t('lines:description.placeholderProduct')
    : isTextLine
      ? t('lines:textLine')
      : t('lines:description.header');

  return (
    <Controller
      control={control}
      name={`${lineFieldName}.description`}
      render={({ field: { name, onBlur, onChange, ref, value }, fieldState: { error, invalid, isDirty, isTouched } }) => (
        <Field.Root className={fieldStyle} dirty={isDirty} invalid={invalid} name={name} touched={isTouched}>
          {!isTextLine && (
            <Field.Label className={clsx(!isMobile && srOnlyStyle)} optional={isProductLine}>
              {label}
            </Field.Label>
          )}

          {isProductLine || isMobile ? (
            <Input
              onBlur={onBlur}
              onValueChange={onChange}
              placeholder={isMobile ? undefined : t('lines:description.placeholderProduct')}
              ref={ref}
              value={value}
            />
          ) : (
            <Textarea
              className={fieldStyle}
              onBlur={onBlur}
              onValueChange={onChange}
              placeholder={t('lines:description.placeholder')}
              ref={ref}
              value={value}
            />
          )}

          {isMobile && <Field.Error match={!!error}>{error?.message}</Field.Error>}
        </Field.Root>
      )}
      rules={{
        required: { value: !isProductLine, message: t('validation:required') },
        validate: (value) => isProductLine || !!value.trim() || t('validation:required'),
      }}
    />
  );
};
